import React, { useState } from 'react';

const ToggleSwitch = ({ initialState = false, onToggle }) => {
    const [isActive, setIsActive] = useState(initialState);

    const handleToggle = () => {
        const newState = !isActive;
        setIsActive(newState);
        if (onToggle) {
            onToggle(newState);
        }
    };

    return (
        <div
            className={`form-check form-switch p-0 d-flex align-items-center`}
            style={{ cursor: 'pointer' }}
        >
            <input
                className="form-check-input m-0"
                type="checkbox"
                role="switch"
                checked={isActive}
                onChange={handleToggle}
                style={{
                    width: '2.5em',
                    height: '1.3em',
                    cursor: 'pointer'
                }}
            />
        </div>
    );
};

export default ToggleSwitch;